import React from "react";
import _ from "lodash";

import useI18n from "Hooks/UseI18n";
import classNames from "classnames";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { useChatOptions } from "MessagingV2/providers/ChatOptionsProvider";
import {
  goToMessagingV2FormRoute,
  setIniFormSubmittedModal,
} from "MessagingV2/modules/MessagingModule";

import { useDispatch } from "Hooks/useDispatch";
import { PageFoldPortraitOutlined } from "@toddle-edu/ds-icons";
import classes from "./FormMessage.scss";
import { Button, Tooltip } from "@toddle-edu/ds-web";
import { isIdEqual } from "Utils";
import { getUserId } from "modules/CommonSelectors";

const FormMessage = props => {
  const { message } = props;

  const messageId = _.get(message, "id");
  const { t } = useI18n(["common"]);
  const attachment = _.first(_.get(message, "attachments", []));
  const titleRef = React.useRef();
  const dispatch = useDispatch();
  const descriptionRef = React.useRef();
  const { chatId } = useChatOptions();

  const interaction = _.get(attachment, "interaction", {});

  const title = _.get(interaction, "title", "");
  const description = _.get(interaction, "description", "");

  const formId = _.get(interaction, "id");

  const scrollWidth = titleRef?.current?.scrollWidth;
  const clientWidth = titleRef?.current?.clientWidth;
  const showTitleToolTip = scrollWidth > clientWidth;

  const scrollDescriptionWidth = descriptionRef?.current?.scrollWidth;
  const clientDescriptionWidth = descriptionRef?.current?.clientWidth;
  const showDescriptionToolTip =
    scrollDescriptionWidth > clientDescriptionWidth;

  const goToFormRoute = () => {
    dispatch(goToMessagingV2FormRoute({ chatId, formId, messageId }));
  };

  const isResponseActive = _.get(interaction, "isResponseActive", false);

  const isRespondedByUser = _.get(interaction, "isRespondedByUser", false);

  const formCreatorId = _.get(interaction, "createdBy.id");
  const isFormCreator = isIdEqual(formCreatorId, getUserId());

  const subText = isResponseActive
    ? description
    : t("common:form_no_longer_accepting_responses");

  const onViewFormClick = () => {
    if (isRespondedByUser) {
      dispatch(
        setIniFormSubmittedModal({
          chatId,
          formId,
          messageId,
        })
      );
    } else {
      goToFormRoute();
    }
  };

  return (
    <div className={classes.formContainer}>
      <div className={classes.iconContainer}>
        <PageFoldPortraitOutlined />
      </div>
      <div className={classes.formDetailContainer}>
        <ConditionalWrapper
          wrapper={<Tooltip tooltip={title} />}
          condition={showTitleToolTip}
          type={"wrapperAsElement"}
        >
          <div
            ref={titleRef}
            className={classNames("text-body", classes.truncatedText)}
          >
            {title}
          </div>
        </ConditionalWrapper>

        <ConditionalWrapper
          wrapper={<Tooltip tooltip={subText} />}
          condition={showDescriptionToolTip}
          type={"wrapperAsElement"}
        >
          <div
            ref={descriptionRef}
            className={classNames(
              "text-body-s",
              classes.textDescription,
              classes.truncatedText,
              {
                [classes.warningText]: !isResponseActive,
              }
            )}
          >
            {subText}
          </div>
        </ConditionalWrapper>
      </div>
      <Button
        dsVersion="2.0"
        variant="neutral"
        type="outlined"
        disabled={!isFormCreator && !isResponseActive && !isRespondedByUser}
        onClick={onViewFormClick}
      >
        {t("common:view")}
      </Button>
    </div>
  );
};

export default FormMessage;
